import React from 'react';
// import DashboardLayout from '../components/Layouts/DashboardLayout';
import DashboardSidebar from '../components/DashboardComponents/DashboardSidebar';
import InnerBanner from '../components/PagesComponents/InnerBanner';
import ExistingInventory from '../components/DashboardComponents/ExistingInventory';
const SellerDashboard = () => {
 return (
    <>
{/* <InnerBanner pageKey="sellerDashboard" /> */}

      <section className='dashboard'>
        <div className='container'>
            <div className='row'>
                <div className='col-lg-12'>
                   <ExistingInventory/> 
                </div>
               
            </div>
        </div>
      </section>
    </>
 );

};

export default SellerDashboard;